import React, { forwardRef, useState } from "react";
import { Block, Layer, useThemeName } from "thorium-ui";
import ProjectComponents from "../components/projects";
import projectsList from "../projects.json";

const getAll = () => {
   let allList = [];
   for (const p of Object.values(projectsList)) {
      allList = [...allList, ...p];
   }
   return allList;
};

export const Projects = forwardRef((props, ref) => {
   const themeName = useThemeName();
   const [projects, setProjects] = useState(getAll());

   const handleChange = (data) => {
      setProjects(data === "all" ? getAll() : projectsList[data]);
   };

   return (
      <div
         id="projects-view"
         className={`suspense-wrapper projects-view ${themeName}`}
         ref={ref}
      >
         <Layer
            justify="center"
            className={`section ${props.visible ? "visible" : ""}`}
         >
            <ProjectComponents.ProjectNav onChange={handleChange} />
            <Block xs={12} sm={12} md={12} lg={10} xl={8} className="px-0">
               <ProjectComponents.ProjectDisplay projects={projects} />
            </Block>
         </Layer>
      </div>
   );
});

export default Projects;
